import { render, staticRenderFns } from "./NewDepartment.vue?vue&type=template&id=aad18c8c&scoped=true&"
import script from "./NewDepartment.vue?vue&type=script&lang=js&"
export * from "./NewDepartment.vue?vue&type=script&lang=js&"
import style0 from "./NewDepartment.vue?vue&type=style&index=0&id=aad18c8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad18c8c",
  null
  
)

export default component.exports